import React from 'react';
import ReactApexChart from 'react-apexcharts';

interface GenderPieChartProps {
  labels: string[];
  series: number[];
  genderDistribution: {
    male: string;
    female: string;
  };
}

const GenderPieChart: React.FC<GenderPieChartProps> = ({ 
  labels, 
  series, 
  genderDistribution 
}) => {
  const options = {
    chart: {
      type: 'pie',
    },
    labels: labels,
    colors: ['#F7F5FF', '#CB72FF'],
    legend: {
      position: 'bottom',
      markers: { radius: 12 },
    },
    dataLabels: { enabled: false },
  };

  return (
    <div className="flex-1 w-full border rounded-lg lg:p-6 p-3 bg-white flex lg:space-x-10">
      <ReactApexChart options={options} series={series} type="pie" height={250} />
      <div className="flex lg:flex-row flex-col items-center justify-center lg:space-x-24 lg:space-y-0 space-y-5 w-full mt-4">
        <div className="flex flex-col space-y-1">
          <div className="flex items-center space-x-2">
            <span className="w-4 h-4 rounded-full bg-[#F7F5FF]"></span>
            <span className="text-sm font-normal font-inter text-[#4A4D4F]">Male</span>
          </div>
          <span className="text-black font-semibold font-inter text-[26px]">
            {genderDistribution.male}
          </span>
        </div>
        <div className="flex flex-col space-y-1 ml-6">
          <div className="flex items-center space-x-2">
            <span className="w-4 h-4 rounded-full bg-[#CB72FF]"></span>
            <span className="text-sm font-normal font-inter text-[#4A4D4F]">Female</span>
          </div>
          <span className="text-black font-semibold font-inter text-[26px]">
            {genderDistribution.female}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GenderPieChart;